import {DecimalPipe} from '@angular/common';
import {Component} from '@angular/core';
import {FormBaseComponent, ValidatorService} from '@utils-lib';
import {HoeheDerBeteiligung} from '@nachdigal';
import {FormBuilder} from '@angular/forms';
import {TranslateService} from '@ngx-translate/core';
import {DatevMessageService} from '@datev/ngx-ui-components';

@Component({
    selector: 'common-ui-hoehe-der-beteiligung',
    templateUrl: './hoehe-der-beteiligung.component.html',
  styleUrls: ['./hoehe-der-beteiligung.component.scss']
})
export class HoeheDerBeteiligungComponent extends FormBaseComponent<HoeheDerBeteiligung> {

    constructor(private readonly formBuilder: FormBuilder,
                private readonly validatorService: ValidatorService,
                private readonly translateService: TranslateService,
                private readonly decimalPipe: DecimalPipe,
                protected readonly messageService: DatevMessageService) {
        super(messageService);
    }

    public onNominellChanged(value: string): void {
        this.data.hoeheDerBeteiligungNominell = this.convertToRoundedNumber(value, 2);
        this.form.get('hoeheDerBeteiligungNominell').setValue(this.toGermanFormat(this.data.hoeheDerBeteiligungNominell, 2));
    }

    public onProzentChanged(value: string): void {
        this.data.hoeheDerBeteiligungProzent = this.convertToRoundedNumber(value, 4);
        this.form.get('hoeheDerBeteiligungProzent').setValue(this.toGermanFormat(this.data.hoeheDerBeteiligungProzent, 4));
    }

    protected createForm(): void {
        this.form = this.formBuilder.group({
            hoeheDerBeteiligungNominell: [
                this.data.hoeheDerBeteiligungNominell, [
                    this.validatorService.pattern('^\\d{1,12}(\\.\\d{2})?$',
                        this.translateService.instant('COMMON_UI.VALIDATION.ANTEILSEIGNER_HOEHE_BETEILIGUNG_NOMINELL'))
                ]
            ],
            hoeheDerBeteiligungProzent: [
                this.data.hoeheDerBeteiligungProzent,
                [
                    this.validatorService.required(),
                    this.validatorService.pattern(
                        '^(?=.{1,8}$)(?!0\\d)^0$|^[0](\\.\\d{1,4})$|^[1-9][0-9]?(\\.\\d{1,4})?$|^100(\\.[0]{1,4})$|^100$',
                        this.translateService.instant('COMMON_UI.VALIDATION.ANTEILSEIGNER_HOEHE_BETEILIGUNG_PROZENT'))
                ]
            ]
        });
    }

    private convertToRoundedNumber(value: string, decimalPlaces = 2): number | undefined {
      value = value.replace(/\./g, '').replace(',', '.');
      if (Number(value)) {
        try {
          return +this.decimalPipe.transform(value, '.2-' + decimalPlaces, 'en').replace(/,/g, '');
        } catch {
        }
      }
      return undefined;
    }

  private toGermanFormat(value: number | unknown, maxDecimals = 4): string {
    if (!value) {
      return '';
    }
    return this.decimalPipe.transform(Number(value), '.2-' + maxDecimals, 'en').replace(/,/g, '').replace(/\./g, ',');
  }

}
